import * as YupSchemas from 'helpers/yup/yup-schemas';
import { object } from 'yup';

export const termSchema = YupSchemas.strictString().min(3).required();

export default object({
  term: termSchema
});
